import React, { forwardRef, useEffect, useState } from 'react';
import { forceVisible } from 'react-lazyload';

import Button from '../../library/button/button';
import ProductSpecifications from '../product-specifications/product-specifications';

import { QueryFiltersState } from '../../pages/product-detail-page/hooks/use-pdp-product/use-pdp-product';

import { Fitment } from '../../shared/types/fitment';
import { Maybe, ProductData, ToolTips } from '../../shared/types/graphql-types';

import './product-details.scss';

interface ProductDetailsProps {
  className?: string;
  hideSizeTable?: boolean;
  isCanonicalSearch: boolean;
  onSizeSelected?: (selectedFilters) => void;
  product: ProductData;
  productType: string;
  queryFilters: QueryFiltersState[] | null;
  selectedFitment: Fitment;
  shouldForceRenderLazyChildren?: boolean;
  storeCode?: Maybe<string>;
  tooltips: ToolTips;
}

const ProductDetails = forwardRef<HTMLDivElement, ProductDetailsProps>(
  function ProductDetails(props, ref) {
    const {
      className = '',
      hideSizeTable,
      isCanonicalSearch,
      onSizeSelected,
      product,
      productType,
      queryFilters,
      selectedFitment,
      shouldForceRenderLazyChildren,
      storeCode,
      tooltips
    } = props;

    const [descriptionExpanded, setDescriptionExpanded] = useState(false);

    useEffect(() => {
      if (shouldForceRenderLazyChildren) {
        forceVisible();
      }
    }, [shouldForceRenderLazyChildren]);

    return (
      <div
        className={`product-details ${className}`}
        ref={ref}
        styleName="product-details"
      >
        {(product?.longDescription || product?.description) && (
          <div
            className="product-details__product-description"
            styleName="product-description"
          >
            <div
              className="cms-content"
              dangerouslySetInnerHTML={{
                __html: product?.longDescription ?? product.description ?? ''
              }}
              styleName={
                descriptionExpanded
                  ? 'description-expanded'
                  : 'description-collapsed'
              }
            />

            {product?.longDescription && (
              <Button
                onClick={() => setDescriptionExpanded(!descriptionExpanded)}
                styleName="product-description-expansion-button"
              >
                {descriptionExpanded
                  ? 'read less'
                  : 'read full product description'}
              </Button>
            )}
          </div>
        )}

        {product && (
          <ProductSpecifications
            hideSizeTable={hideSizeTable}
            isCanonicalSearch={isCanonicalSearch}
            onSizeSelected={onSizeSelected}
            product={product}
            productType={productType}
            queryFilters={queryFilters}
            selectedFitment={selectedFitment}
            storeCode={storeCode}
            styleName="product-specifications"
            tooltips={tooltips}
          />
        )}
      </div>
    );
  }
);

export default ProductDetails;
